import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../../hooks/useLang';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useLogout } from '../../hooks/useLogout';
import ThemeToggle from './ThemeToggle';
import LogoMark from '../LogoMark';
import '../../styles/components/Navbar.scss';

const Navbar = ({ hideDashboard }) => {
    const { language } = useLang();
    const { user } = useAuthContext();
    const { logout } = useLogout();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate(`/${language}`);
    };

    return (
        <nav className="main-navbar sticky top-0 z-50 bg-nav-bg/70 backdrop-blur-xl border-b border-nav-hover transition-all duration-300">
            <div className="w-full px-6 h-14 flex items-center justify-between">
                <div className="nav-logo flex items-center gap-2">
                    <LogoMark to={`/${language}`} iconHeight={40} textHeight={24} />
                </div>

                <div className="hidden md:flex items-center gap-1">
                    {user ? (
                        <>
                            <Link to={`/${language}/dashboard`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Dashboard</Link>
                            <Link to={`/${language}/notes`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">My Books</Link>
                            <Link to={`/${language}/library`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Library</Link>
                            {/* <Link to={`/${language}/community`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Community</Link> */}
                            {/* <Link to={`/${language}/ai`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">AI Tools</Link> */}
                            {/* <Link to={`/${language}/opportunities`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Opportunities</Link> */}
                        </>
                    ) : (
                        <>
                            <Link to={`/${language}`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Home</Link>
                            <Link to={`/${language}/library`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Library</Link>
                            <Link to={`/${language}/events`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Events</Link>
                            <Link to={`/${language}/careers`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Careers</Link>
                            <Link to={`/${language}/about`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">About us</Link>
                            <Link to={`/${language}/contact`} className="px-4 py-2 text-sm font-medium transition-colors text-nav-foreground/60 hover:text-nav-foreground no-underline border-b-2 border-transparent hover:border-primary/40">Contact us</Link>
                        </>
                    )}
                </div>

                <div className="nav-actions flex items-center gap-3">
                    {!user ? (
                        <>
                            <Link to={`/${language}/login`} className="px-4 py-2 text-sm font-medium text-nav-foreground/80 hover:text-nav-foreground transition-colors">Log In</Link>
                            <Link to={`/${language}/signup`} className="px-5 py-2.5 rounded-xl bg-primary text-primary-foreground text-sm font-bold hover:bg-primary/90 transition-all active:scale-95 shadow-lg shadow-primary/10">Create Account</Link>
                        </>
                    ) : (
                        <>
                            <Link to={`/${language}/dashboard`} className="flex items-center gap-2 pl-1 pr-3 py-1 rounded-xl bg-nav-hover hover:bg-nav-hover/80 transition-colors">
                                <i className="fa-solid fa-circle-user text-nav-foreground/60 text-lg"></i>
                                <span className="text-sm font-medium text-nav-foreground hidden sm:block truncate max-w-[120px]">
                                    {user.firstname || user.user?.firstname || user.username || user.user?.username || 'Profile'}
                                </span>
                            </Link>
                            <button onClick={handleLogout} className="px-4 py-2 text-xs font-bold text-nav-foreground/60 hover:text-destructive transition-colors uppercase tracking-wider">Log out</button>
                        </>
                    )}
                    <div className="h-6 w-px bg-nav-foreground/10 mx-1 hidden sm:block" />
                    <ThemeToggle />
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
